import { useState } from 'react';

export const About = () => {
  const [activeTab, setActiveTab] = useState(0);

const tabs = [
  {
    label: 'Über mich',
    content: `Ich bin Tobias Bollinger, 27 Jahre alt, und Elektromeister mit dem Fokus auf Photovoltaik- und Heizungssysteme. In den letzten Jahren habe ich zahlreiche Projekte im Neubau und in Bestandsgebäuden begleitet – von der Planung bis zur Umsetzung. Die Praxisnähe ist dabei mein größter Vorteil: Ich weiß, was wirklich funktioniert – und was nicht.`,
  },
  {
    label: 'Meine Qualifikation',
    content: `Um meine Kundinnen und Kunden noch umfassender beraten zu können, habe ich die Weiterbildung zum Gebäudeenergieberater (HWK) an der Handwerkskammer Ulm abgeschlossen. Damit bin ich berechtigt, energetische Sanierungen fachlich zu begleiten, Energieausweise zu erstellen und Fördermittel optimal einzubinden – immer auf dem neuesten Stand der Vorschriften.`,
  },
  {
    label: 'Mein Anspruch',
    content: `Ich suche für jedes Projekt die beste Lösung: individuell, effizient und zukunftssicher. Dabei nehme ich mir Zeit für eine ehrliche, persönliche Beratung. Ob es um Photovoltaik, Heizsysteme oder die ganzheitliche Energieoptimierung deines Zuhauses geht: Ich bin von Anfang bis Ende an deiner Seite.`,
  },
];

  return (
    <section className="about anchor-offset" id="about">
      <h2>Über mich</h2>
      <div className="tab-buttons">
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={activeTab === index ? 'active' : ''}
            onClick={() => setActiveTab(index)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="about-content">
        <p>{tabs[activeTab].content}</p>
      </div>
    </section>
  );
};
